import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class DisbursementService {
  userDetails: any;
  roleId: any;
  userId: any;
  roleName: any;
  accountingFirmId: any;

  constructor(private http: HttpClient) {
    this.accountingFirmId = localStorage.getItem('AccountFirmId');
  }
  
  addEditDisbursement(Disbursement) {
    return this.http.post<any>('API/Disbursement/AddEditDisbursement',  Disbursement )
  }

  addEditDisbursementMaster(disbursementData) {
    return this.http.post<any>('API/Disbursement/AddEditDisbursementMaster', disbursementData);
  }

  GetDisbursementDetail(dmid) {
    return this.http.get<any>('API/Disbursement/GetDisbursementById?did=' + dmid)
  }

  DeleteDisbursement(DisbursementID) {
    return this.http.get<any>('Disbursement/DeleteDisbursement?dmid=' + DisbursementID);
  }

  DisbursementArchiveById(DID) {
    return this.http.post<any>('API/Disbursement/DisbursementArchiveById?did=', DID)
  }

  GetDisbursementMasterById(DisbursementID) {
    return this.http.get<any>('API/Disbursement/GetDisbursementMasterById?dmid=' + DisbursementID);
  }

  GetDisbursementMasterCombo() {
    return this.http.get<any>('API/Disbursement/GetDisbursementMasterListForCombo');
  }

  GetDisbursementdetailsbyJobId(JobId) {
    return this.http.get<any>('Disbursement/GetDisburesementDetailsbyJobId?JobId=' + JobId);
  }

  GetMasterDisbursementList() {
    return this.http.get<any>('API/Disbursement/GetMasterDisbursementList');
  }

  GetDisbursementById(DisbursementID) {
    return this.http.get<any>('API/Disbursement/GetDisbursementMasterList?dmid=' + DisbursementID);
  }

  DisbursementMasterArchiveById(DisbursementID, isArchive) {
    return this.http.get<any>('API/Disbursement/DisbursementMasterArchiveById?dmid=' + DisbursementID + '&isArchive=' + isArchive);
  }

  DeleteMasterDisbursement(DisbursementID, isDeleted) {
    return this.http.get<any>('API/Disbursement/DisbursementMasterDeleteById?dmid=' + DisbursementID + '&isDeleted=' + isDeleted);
  }

  getBulkDisbursementFileSummary() {
    return this.http.get<any>('api/Disbursement/GetBulkDisbursementFileSummary?accountingFirmId='+ this.accountingFirmId);
  }

  getBulkDisbursementFileLogData(disbursementID) {
    return this.http.get<any>('api/Disbursement/GetBulkDisbursementFileLogData?disbursementFileId='+ disbursementID + '&accountingFirmId=' + this.accountingFirmId);
  }

  generateBulkDisbursementsInvoicePreview(requestObject) {
    return this.http.post<any>('api/Disbursement/GenerateBulkDisbursementsInovicePreview', requestObject);
  }

  getBillingEntityDisbursementsListInovicePreview(fileId, billingEntity, debtorClientId, GSTType) {
    return this.http.get<any>('api/Disbursement/GetBillingEntityDisbursementsListInovicePreview?disbursementFileId='+ fileId + '&billingEntity=' + billingEntity + '&debtorClientId=' + debtorClientId + '&gstType=' + GSTType);
  }

  generateBulkDisbursementsInvoice(requestObject) {
    return this.http.post<any>('api/Disbursement/GenerateBulkDisbursementInvoices', requestObject);
  }

  getBulkDisbursementsInvoiceList(disbursementID) {
    return this.http.get<any>('api/Disbursement/GetBulkDisbursementsInvoiceList?disbursementFileId=' + disbursementID);
  }
}
